
export function underwriterRateToForm(rate) {
    let cleanedRate = Object.assign({}, rate);

    if (cleanedRate.company !== undefined && cleanedRate.company.id !== undefined) {
        cleanedRate.company = cleanedRate.company.id;
    }

    return cleanedRate;
}

export function underwriterRatesToSelect(rates) {
    let cleanedRates = [];

    rates.map((item) => (
        cleanedRates.push({
            label: item.name + " (" + item.rate + "%)",
            value: item.id,
            item: item,
        })
    ));
    return cleanedRates;
}


// WEBPACK FOOTER //
// ./src/utils/underwriterRate.js